// material-ui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

// ==============================|| LOADER (NO TOP PROGRESS BAR) ||============================== //

/**
 * מכסה את אזור התוכן בלבד — נשאר **מתחת** ל־Sidebar (1099) ול־AppBar (1150) ולשורות התפריט (1201),
 * כדי שניווט לתצוגה אחרת יתאפשר גם בזמן טעינה. בעליית האפליקציה אין כרום ולכן הכיסוי מלא כשהיה.
 */
export default function Loader() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1090,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
      }}
    >
      <CircularProgress color="primary" size={40} />
    </Box>
  );
}
